import Vue from 'vue'
import AppAutocomplete from './components/AppAutocomplete.vue'
import AppButton from './components/AppButton/AppButton.vue'
import AppChip from './components/AppChip/AppChip.vue'
import AppCopyableText from './components/AppCopyableText.vue'
import AppCard from './components/AppCard/AppCard.vue'
import AppPage from './components/AppPage/AppPage.vue'
import AppPagination from './components/AppPagination/AppPagination.vue'
import AppSelect from './components/AppSelect.vue'
import AppTable from './components/AppTable/AppTable.vue'
import AppTextField from './components/AppTextField.vue'
import AppToolbar from './components/AppToolbar/AppToolbar.vue'
import './core.scss'

Vue.component('AppAutocomplete', AppAutocomplete)
Vue.component('AppButton', AppButton)
Vue.component('AppCard', AppCard)
Vue.component('AppChip', AppChip)
Vue.component('AppCopyableText', AppCopyableText)
Vue.component('AppPage', AppPage)
Vue.component('AppPagination', AppPagination)
Vue.component('AppSelect', AppSelect)
Vue.component('AppTable', AppTable)
Vue.component('AppTextField', AppTextField)
Vue.component('AppToolbar', AppToolbar)
